import { LocationPreference } from './location-preference';
import { PreferenceGroupType } from './preference-group-type';
import { PreferenceSortType } from './preference-sort-type';
import { UserCompanyPreference } from './user-company-preference';

export class SessionPreference {
    sort: PreferenceSortType;
    group: PreferenceGroupType;
    company: UserCompanyPreference;
    location: LocationPreference;
    previousLocation: LocationPreference;
}
